<template>
  <div class="root">
    <ul class="ul_left">
      <li v-for="(item, index) in li_bg" :key="index" @click="changeBg(index)">
        <img :src="index == idx ? item.on : item.off" alt />
      </li>
    </ul>
    <ul class="ul_right">
      <li
        class="li_right"
        v-for="(title1, index1) in titles[idx].list.slice(
          (currentpage - 1) * pagesize,
          currentpage * pagesize
        )"
        :key="index1"
      >
        <router-link :to="{ name: '竞价项目详情', query: { id: title1.id } }">{{
          title1.projectname
        }}</router-link>
        <p>
          <span>{{ title1.logintime }}</span>
          <!-- <span>来源：{{cityDetail.cityName}}日报</span> -->
        </p>
      </li>
    </ul>

    <div v-if="titles[idx].list.length > 0">
      <el-pagination
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        layout="prev, pager, next, jumper"
        :total="titles[idx].list.length"
      ></el-pagination>
    </div>
    <h3 v-else style="font-size: 24px">暂无数据</h3>
  </div>
</template>

<script>
export default {
  data () {
    return {
      idx: 0,
      li_bg: [
        {
          on: require('../assets/img/土地1.png'),
          off: require('../assets/img/土地0.png'),
        },
        {
          on: require('../assets/img/四荒地1.png'),
          off: require('../assets/img/四荒地0.png'),
        },
        {
          on: require('../assets/img/实物资产1.png'),
          off: require('../assets/img/实物资产0.png'),
        },
        {
          on: require('../assets/img/养殖水面1.png'),
          off: require('../assets/img/养殖水面0.png'),
        },
        {
          on: require('../assets/img/林地林木1.png'),
          off: require('../assets/img/林地林木0.png'),
        },
        {
          on: require('../assets/img/闲置宅基地1.png'),
          off: require('../assets/img/闲置宅基地0.png'),
        },
        {
          on: require('../assets/img/知识产权1.png'),
          off: require('../assets/img/知识产权0.png'),
        },
        {
          on: require('../assets/img/招投标1.png'),
          off: require('../assets/img/招投标0.png'),
        },
        {
          on: require('../assets/img/其他1.png'),
          off: require('../assets/img/其他0.png'),
        },
        {
          on: require('../assets/img/房屋所有权1.png'),
          off: require('../assets/img/房屋所有权0.png'),
        },
        {
          on: require('../assets/img/生产性设施1.png'),
          off: require('../assets/img/生产性设施0.png'),
        },
        {
          on: require('../assets/img/建设用地1.png'),
          off: require('../assets/img/建设用地0.png'),
        },
      ],
      titles: [],
      //   每页数据条数
      pagesize: 10,
      currentpage: 1,
      inputpage: 1,
      dm: '',
    }
  },
  created () {
    this.dm = this.$route.query.dm ? this.$route.query.dm : ''

    let url = 'jingjiaxiangmugengduo'
    // console.log('竞价项目更多');
    // console.log(this.ajax_url(url).data);
    this.titles = this.ajax_url(url, this.dm).data
    // 重置idx
    this.idx = this.$route.query.id ? this.$route.query.id : 0
  },
  mounted () { },
  computed: {},
  watch: {},
  methods: {
    changeBg (i) {
      this.$router.push({ name: '竞价项目', query: { id: i } })
      this.idx = i
    },
    // 当前每夜多少条
    handleSizeChange (size) {
      this.pagesize = size
    },
    // 当前页数
    handleCurrentChange (currentpage) {
      this.currentpage = currentpage
    },
  },
}
</script>

<style scoped>
.root {
  min-height: 1180px;
  margin: 0 auto;
  margin-bottom: 35px;
  width: 1860px;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
  opacity: 1;
  overflow: hidden;
}

.ul_left {
  display: block;
  width: 260px;
  height: auto;
  float: left;
  /* background-color: rebeccapurple; */
  padding: 40px 100px;
  list-style: inside none;
}

.ul_left > li {
  display: block;
  width: 260px;
  height: 92px;
  /* background-color: red; */
  margin-bottom: 10px;
  cursor: pointer;
}

.ul_right {
  display: block;
  width: 1300px;
  max-height: 1230px;
  overflow: hidden;
  list-style: inside none;
  margin-bottom: 40px;
}

.ul_right .li_right {
  display: block;
  width: 1300px;
  height: 122px;
  border-bottom: 1px dotted #bebebe;
}

.li_right > a {
  display: block;
  padding: 37px 0 19px 0;
  max-width: 1200px;
  height: 26px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 26px;
  color: #666666;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.li_right > p {
  display: block;
  width: auto;

  height: 21px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 21px;
  color: #999999;
}

.li_right > p > span {
  display: inline-block;
  width: 250px;
}

.el-pagination {
  text-align: center;
}
</style>
